module.exports = __webpack_public_path__ + "img/Centerparks.d845c1c2.jpg";